import { css } from 'glamor';
import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { CheckboxInputProps } from '../input/basicInputs';
import classNames from 'classnames';
import { Classes } from '@blueprintjs/core';
import CheckboxInput from '../input/basicInputs/CheckboxInput';

const formFieldClassName = classNames(Classes.FORM_GROUP, css({ margin: 0 }).toString());

class CheckboxInputFormField extends React.Component<BaseFormFieldProps & CheckboxInputProps> {
  render() {
    // @ts-ignore
    const { label, ...otherProps } = this.props;
    return (
      <FormField {...otherProps} className={formFieldClassName} type="checkbox">
        {({ input }) => (
          <CheckboxInput
            {...input}
            onChange={(e) => {
              input.onChange(e);
              if (this.props.onChange) {
                this.props.onChange(e);
              }
            }}
            label={label}
          />
        )}
      </FormField>
    );
  }
}

export default CheckboxInputFormField;
